import { ThemedItinerary } from "@/components/ThemedItinerary";
import { spotImg } from "@/data/planner";
import { Link } from "react-router-dom";

const cfg = {
  testid: "kids-itinerary-page",
  seo: {
    title: "Copenhagen with Kids: A 3-Day Family Itinerary",
    description:
      "A realistic 3-day Copenhagen itinerary for families — the Blue Planet aquarium, Nyhavn and a canal tour, Kastellet's grassy ramparts, the Experimentarium, Nordhavn's rooftop playground, the Round Tower and a day at Tivoli.",
    path: "/copenhagen-with-kids-itinerary",
  },
  heroBg: "#0E3A4A",
  heroImgId: "tivoli",
  accent: "#FDB022",
  eyebrow: "THE FAMILY ITINERARY",
  h1: "3 days in Copenhagen",
  h1Italic: "with kids",
  intro: (
    <>
      Copenhagen is a dream with children — flat, safe, full of water and animals and
      playgrounds. This three-day plan keeps the walking short, mixes indoor rescues with
      outdoor fun, and saves Tivoli for the grand finale. For a full list of attractions,
      playgrounds and family food, see our{" "}
      <Link
        to="/copenhagen-with-kids"
        data-testid="kids-itinerary-guide-link"
        className="font-700 underline decoration-2 underline-offset-2 hover:opacity-80 transition-opacity"
        style={{ color: "#FDB022" }}
      >
        Copenhagen-with-kids guide
      </Link>
      .
    </>
  ),
  days: [
    {
      label: "DAY ONE",
      title: "Aquarium &",
      titleAccent: "the postcard harbour",
      blurb:
        "Open with the big one: Den Blå Planet, Northern Europe's largest aquarium, out by the airport Metro — go first thing, as it's a ride from town and shuts mid-afternoon. Then ride the Metro straight back to Kongens Nytorv for Nyhavn, a canal boat tour and the royal square at Amalienborg. If there's energy left, walk up the waterfront to Kastellet — the star-shaped fortress with grassy ramparts to run along, and the Little Mermaid right beside it.",
      ids: ["blaaplanet", "nyhavn", "canaltour", "amalienborg", "littlemermaid"],
    },
    {
      label: "DAY TWO",
      title: "Hands-on science &",
      titleAccent: "a rooftop playground",
      blurb:
        "A morning at the Experimentarium — a whole building of hands-on science, bubbles and water play, and the best rainy-day rescue in the city. Afterwards, head to the Nordhavn waterfront: let the kids loose on the Konditaget Lüders rooftop playground high above the harbour, while the grown-ups grab a proper coffee at La Cabra nearby.",
      ids: ["experimentarium", "nordhavn"],
    },
    {
      label: "DAY THREE",
      title: "Gardens, a tower &",
      titleAccent: "a Tivoli finale",
      blurb:
        "Start calm in Kongens Have — the King's Garden, with its big free playground and the puppet theatre in summer — then climb the Round Tower's gentle spiral ramp (no stairs, easy for little legs) for a view over the rooftops. Spend the afternoon and evening at Tivoli Gardens, rides and lights and all.",
      ids: ["kongenshave", "rundetaarn", "tivoli"],
    },
  ],
  cta: { title: "Want to tweak it?", titleItalic: "It loads straight into the planner" },
  shareTitle: "Copenhagen with Kids — A 3-Day Family Itinerary",
  schemaName: "Copenhagen with Kids — A 3-Day Family Itinerary",
  heroImg: spotImg("tivoli", 1600),
  explore: [
    { label: "Everything for families — the Copenhagen with kids guide", to: "/copenhagen-with-kids" },
    { label: "Rainy-day rescues for all ages", to: "/rainy-day" },
    { label: "Build your own version — the free planner", to: "/planner" },
  ],
};

export default function KidsItineraryPage() {
  return <ThemedItinerary cfg={cfg} />;
}
